/* eslint-disable */
import { FieldDefinition } from '../index';

declare var Object: any;
export interface FieldTypeInterface {
  id?: string;
  type?: string;
  isArray?: boolean;
  description?: string;
  defaultComponentType?: string;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
  fields?: FieldDefinition[];
}

export class FieldType implements FieldTypeInterface {
  'id'?: string;
  'type': string;
  'isArray': boolean;
  'description': string;
  'defaultComponentType': string;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  fields: FieldDefinition[];
  constructor(data?: FieldTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FieldType`.
   */
  public static getModelName() {
    return 'FieldType';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of FieldType for dynamic purposes.
   **/
  public static factory(data: FieldTypeInterface): FieldType {
    return new FieldType(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'FieldType',
      plural: 'FieldTypes',
      path: 'field-types',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        type: {
          name: 'type',
          type: 'string',
        },
        isArray: {
          name: 'isArray',
          type: 'boolean',
          default: false,
        },
        description: {
          name: 'description',
          type: 'string',
        },
        defaultComponentType: {
          name: 'defaultComponentType',
          type: 'string',
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
      },
      relations: {
        fields: {
          name: 'fields',
          type: 'FieldDefinition[]',
          model: 'FieldDefinition',
          relationType: 'hasMany',
          keyFrom: 'id',
          keyTo: 'parentFieldTypeId',
        },
      },
    };
  }
}
